/** How long a read's result waits for the form to render it (a section a document turned on, a new mark) before HR is brought to it. */
const RENDER_WAIT_MS = 100

/**
 * Brings HR to a field a finished read wants checked: the first of the first group with a field the form shows, in the order the form
 * shows them. Fields are found by `AutofillField`'s `data-autofill-field`; one the form does not show (a hidden section) is skipped.
 * Returns what cancels it: a form that closes within the wait must not scroll whatever page is showing by then.
 */
export function revealFirstField(groups: ReadonlyArray<ReadonlySet<string>>): () => void {
    if (groups.every((group) => group.size === 0)) return () => undefined
    const timer = window.setTimeout(() => {
        const shown = Array.from(document.querySelectorAll<HTMLElement>('[data-autofill-field]'))
        for (const group of groups) {
            const target = shown.find((element) => group.has(element.dataset.autofillField ?? ''))
            if (target) return target.scrollIntoView?.({ behavior: 'smooth', block: 'center' })
        }
    }, RENDER_WAIT_MS)
    return () => window.clearTimeout(timer)
}
